// thunks/logsThunks.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  customerBulkUploadService, DisputeBulkUploadService,
  fetchdisputeLogFileByName, fetchdisputeLogFiles, fetchLogFileByName, fetchLogFiles
} from "../../../services/BulkUploadService";

import { setError, setLoading, setUploadProgress, setUploadResults, setUploadStatus } from "../slices/BulkUploadSlice";

export const uploadCustomerBulk = createAsyncThunk(
  'customerBulkUpload/upload',
  async ({ file, type }, { dispatch, rejectWithValue }) => {
    try {
      dispatch(setLoading(true));
      dispatch(setError(null));
      dispatch(setUploadStatus('Uploading...'));
      dispatch(setUploadProgress(0));

      const response = await customerBulkUploadService.uploadCustomerBulk(file, type, (progress) => {
        dispatch(setUploadProgress(progress));
      });

      dispatch(setUploadProgress(100));
      dispatch(setUploadStatus('Processing data...'));

      await new Promise(resolve => setTimeout(resolve, 1000));

      dispatch(setUploadResults(response));
      dispatch(setUploadStatus('Upload complete!'));

      return response;
    } catch (error) {
      dispatch(setError(error.message || 'Upload failed'));
      dispatch(setUploadStatus('Error: Upload failed'));
      return rejectWithValue(error.message || "Something went wrong");
    } finally {
      dispatch(setLoading(false));
    }
  }
);

export const downloadTemplate = createAsyncThunk(
  'customerBulkUpload/downloadTemplate',
  async (type, { rejectWithValue }) => {
    try {
      const blob = await customerBulkUploadService.downloadTemplate(type);

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `${type}_bulk_upload_template.csv`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      return `${type} template downloaded successfully!`;
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);


// customer bulkupload
export const getLogFilesThunk = createAsyncThunk(
  "logs/fetch",
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetchLogFiles();
      return response?.reverse() || [];
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);

// Get a single log file by fileName
export const getLogFileByNameThunk = createAsyncThunk(
  "logs/fetchByName",
  async (fileName, { rejectWithValue }) => {
    try {
      const response = await fetchLogFileByName(fileName);
      return response;
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);


















// dispute bulkupload


export const uploadDisputeBulk = createAsyncThunk(
  "disputeBulkUpload/upload",
  async ({ file, type }, { dispatch, rejectWithValue }) => {
    try {
      dispatch(setLoading(true));
      dispatch(setError(null));
      dispatch(setUploadStatus("Uploading..."));
      dispatch(setUploadProgress(0));

      const response = await DisputeBulkUploadService.uploadDisputeBulk(
        file,
        type,
        (progress) => {
          dispatch(setUploadProgress(progress));
        }
      );

      dispatch(setUploadProgress(100));
      dispatch(setUploadStatus("Processing data..."));
      await new Promise((resolve) => setTimeout(resolve, 1000));

      dispatch(setUploadResults(response));
      dispatch(setUploadStatus("Upload complete!"));

      return response;
    } catch (error) {
      dispatch(
        setError(error.message || "Upload failed")
      );
      dispatch(setUploadStatus("Error: Upload failed"));
      return rejectWithValue(error.message || "Something went wrong");
    } finally {
      dispatch(setLoading(false));
    }
  }
);

export const downloadDisputeTemplate = createAsyncThunk(
  'disputeBulkUpload/downloadTemplate',
  async (type, { rejectWithValue }) => {
    try {
      const blob = await DisputeBulkUploadService.downloadTemplate(type);

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `${type}_bulk_upload_template.csv`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      return `${type} template downloaded successfully!`;
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);




// get
export const getdisputeLogFilesThunk = createAsyncThunk(
  "logs/disputefetch",
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetchdisputeLogFiles();
      return response;
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);

// Get a single log file by fileName
export const getdisputeLogFileByNameThunk = createAsyncThunk(
  "logs/disputefetchByName",
  async (fileName, { rejectWithValue }) => {
    try {
      const response = await fetchdisputeLogFileByName(fileName);
      return response;
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);